import { max } from 'd3-array'
import { scaleLinear } from 'd3-scale'
import { select, selectAll } from 'd3-selection'
import d3Tip from 'd3-tip'
import { transition } from 'd3-transition'
import React, { Component } from 'react'

import { Loading } from '../../../../Forms/SharedComponents/components/MuiTable/Loading'

const MARGEN_ENTRE_TEXTO_SECTORES_Y_PROGRESS_BAR = -2
export default class GraficoSilosView extends Component {
  constructor (props) {
    super(props)
    this.createVistaSilos = this.createVistaSilos.bind(this)
    this.lineaClickeada = this.lineaClickeada.bind(this)
    this.lineaHover = this.lineaHover.bind(this)
    this.clearChart = this.clearChart.bind(this)
    this.selectedLinea = null
  }

  lineaClickeada (selectedLinea) {
    this.props.onLineaClickeada && this.props.onLineaClickeada(selectedLinea)
  }

  lineaHover (selectedLinea, silos, entresilos, lineas) {
    this.selectedLinea = selectedLinea
    var t = transition().duration(550)
    selectAll('.entresilo')
      .data(entresilos)
      .transition(t)
      .attr('opacity', (d) => (!this.selectedLinea || d.linea === this.selectedLinea ? 1 : 0.1))
    selectAll('.silo')
      .data(silos)
      .transition(t)
      .attr('opacity', (d) => (!this.selectedLinea || d.linea === this.selectedLinea ? 1 : 0.1))

    selectAll('.linea')
      .data(Object.keys(lineas))
      .transition(t)
      .attr('stroke-opacity', (d) => (this.selectedLinea === d ? 0.9 : 0.6))
      .attr('stroke-width', (d) => (this.selectedLinea === d ? 30 : 15))
    selectAll('.selectorDeLinea')
      .data(Object.keys(lineas))
      .transition(t)
      .attr('opacity', (d) => (this.selectedLinea === d ? 0.9 : 0.6))
      .attr('stroke-width', (d) => (this.selectedLinea === d ? 2 : 0))
  }

  lineaHoverOff (selectedLinea, silos, entresilos, lineas) {
    this.selectedLinea = null
    var t = transition().duration(550)
    selectAll('.entresilo')
      .data(entresilos)
      .transition(t)
      .attr('opacity', (d) => (!this.selectedLinea || d.linea === this.selectedLinea ? 1 : 0.1))
    selectAll('.silo')
      .data(silos)
      .transition(t)
      .attr('opacity', (d) => (!this.selectedLinea || d.linea === this.selectedLinea ? 1 : 0.1))

    selectAll('.linea')
      .data(Object.keys(lineas))
      .transition(t)
      .attr('stroke-opacity', (d) => (this.selectedLinea === d ? 0.9 : 0.6))
      .attr('stroke-width', (d) => (this.selectedLinea === d ? 30 : 15))
    selectAll('.selectorDeLinea')
      .data(Object.keys(lineas))
      .transition(t)
      .attr('opacity', (d) => (this.selectedLinea === d ? 0.9 : 0.6))
      .attr('stroke-width', (d) => (this.selectedLinea === d ? 2 : 0))
  }

  clearChart () {
    const node = select(this.node).node()
    selectAll('.d3-tip').remove()
    if (node) {
      while (node.firstChild) {
        node.removeChild(node.firstChild)
      }
    }
  }

  componentDidMount () {
    this.clearChart()
    this.createVistaSilos(this.props.silosData)
  }

  componentDidUpdate () {
    this.clearChart()
    this.createVistaSilos(this.props.silosData)
  }

  createVistaSilos (data) {
    if (this.props.loading) {
      return
    }
    const { cereal, variedad, filtrado } = this.props
    const nucleos = this.props.nucleos
    let { sectores } = this.props
    let silos = data.filter((silo) => silo.tipo !== 'ENTRSILO' && silo.posicionFisica !== null)
    silos = silos.map(silo => silo.sector === 'S4' ? { ...silo, radio: silo.radio / 1.5 } : silo)
    const entresilos = data.filter((silo) => silo.tipo === 'ENTRSILO')
    const lineas = {}
    data.forEach((silo) => {
      if (silo.linea && !silo.linea.includes('S5')) {
        if (lineas[silo.linea]) {
          lineas[silo.linea] = {
            ...lineas[silo.linea],
            xStart: Math.min(lineas[silo.linea].xStart, silo.posicionX),
            xEnd: Math.max(lineas[silo.linea].xEnd, silo.posicionX)
          }
        } else {
          lineas[silo.linea] = { ...lineas[silo.linea], xStart: silo.posicionX, xEnd: silo.posicionX }
        }
        if (silo.tipo !== 'ENTRSILO') {
          lineas[silo.linea] = { ...lineas[silo.linea], zPos: silo.posicionZ }
        }
      }
    })
    sectores = {
      ...sectores,
      S4: {
        ...sectores['S4'],
        startingXPosition: sectores['S4'].startingXPosition + sectores['S4'].xLarge / 3,
        xLarge: sectores['S4'].xLarge / 1.5
      }
    }
    const node = this.node
    const margin = { top: 50, right: 15, bottom: 50, left: 105 }
    const width = this.props.width - margin.left - margin.right
    const height = this.props.height - margin.top - margin.bottom
    const g = select(node)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
    const tip = d3Tip()
      .style('border', 'solid 1px grey-dark')
      .style('background-color', 'grey')
      .style('color', 'white')
      .style('border-radius', '10px')
      .style('padding', '5px')
      .style('font-family', 'monospace')
      .style('font-size', '14px')
      .attr('class', 'd3-tip')
      .html(function (d) {
        return `<div>${d}</div>`
      })
      .offset([0, 5])
    g.call(tip)
    const yScale = scaleLinear().domain([0, 43]).range([0, height])
    const xScale = scaleLinear()
      .domain([0, max(data, (d) => d.posicionX + d.radio)])
      .range([0, width])
    const rScale = scaleLinear()
      .domain([0, max(data, (d) => d.radio)])
      .range([0, height / 10])
    // sectores
    g.selectAll('.sector')
      .data(Object.keys(sectores))
      .enter()
      .append('rect')
      .attr('x', (d) => {
        return xScale(sectores[d].startingXPosition + 0.5)
      })
      .attr('y', (d) => {
        return yScale(sectores[d].startingZPosition)
      })
      .attr('class', 'sector')
      .attr('width', (d) => {
        return xScale(sectores[d].xLarge - 0.5)
      })
      .attr('height', (d) => {
        return yScale(sectores[d].zLarge)
      })
      .attr('fill', '#eeeeee')
    // lineas
    g.selectAll('.linea')
      .data(Object.keys(lineas))
      .enter()
      .append('line')
      .attr('x1', (d) => xScale(lineas[d].xStart - (2)))
      .attr('x2', (d) => xScale(lineas[d].xEnd + 2))
      .attr('y1', (d) => yScale(lineas[d].zPos))
      .attr('y2', (d) => yScale(lineas[d].zPos))
      .attr('class', (d) => `linea ${d}`)
      .attr('stroke', '#bdbdbd')
      .attr('stroke-width', 15)
      .attr('stroke-opacity', 0.6)
      .on('mouseover', (d) => this.lineaHover(d, silos, entresilos, lineas))
      .on('mouseout', (d) => this.lineaHoverOff(d, silos, entresilos, lineas))
      .on('click', (d) => this.lineaClickeada(d))
    g.selectAll('.selectorDeLinea')
      .data(Object.keys(lineas).filter(l => l !== 'L4-S4'))
      .enter()
      .append('polygon')
      .attr('points', (d) =>
        `${xScale(lineas[d].xStart - 2)},${yScale(lineas[d].zPos)} ${xScale(lineas[d].xStart - 3)},${yScale(
          lineas[d].zPos - 1
        )} ${xScale(lineas[d].xStart - 7.5)},${yScale(lineas[d].zPos - 1)} ${xScale(lineas[d].xStart - 7.5)},${yScale(
          lineas[d].zPos + 1
        )} ${xScale(lineas[d].xStart - 3)},${yScale(lineas[d].zPos + 1)}`
      )
      .attr('opacity', 0.6)
      .style('fill', '#bdbdbd')
      .attr('class', (d) => `selectorDeLinea ${d}`)
    g.selectAll('.lineaTexto')
      .data(Object.keys(lineas).filter(l => l !== 'L4-S4'))
      .enter()
      .append('text')
      .attr('x', (d) => xScale(lineas[d].xStart - 5))
      .attr('y', (d) => yScale(lineas[d].zPos))
      .attr('class', (d) => `lineaTexto ${d}`)
      .attr('opacity', 1)
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'central')
      .text((d) => `-${d.split('-')[0]}-`)
      .on('mouseover', (d) => this.lineaHover(d, silos, entresilos, lineas))
      .on('mouseout', (d) => this.lineaHoverOff(d, silos, entresilos, lineas))
      .on('click', (d) => this.lineaClickeada(d, silos, entresilos, lineas))
    // nucleos
    g.selectAll('.nucleos')
      .data(nucleos)
      .enter()
      .append('polygon')
      .attr(
        'points',
        (d) =>
          `${xScale(d.pos1.x) + xScale(sectores[d.sector].startingXPosition)},${
            yScale(d.pos1.y) + yScale(sectores[d.sector].startingZPosition)
          } ${xScale(d.pos2.x) + xScale(sectores[d.sector].startingXPosition)},${
            yScale(d.pos2.y) + yScale(sectores[d.sector].startingZPosition)
          } ${xScale(d.pos3.x) + xScale(sectores[d.sector].startingXPosition)},${
            yScale(d.pos3.y) + yScale(sectores[d.sector].startingZPosition)
          } ${xScale(d.pos4.x) + xScale(sectores[d.sector].startingXPosition)},${
            yScale(d.pos4.y) + yScale(sectores[d.sector].startingZPosition)
          }`
      )
      .attr('opacity', 0.4)
      .style('fill', (d) => d.color)
      .attr('class', (d) => `nucleo ${d.nombre}`)
      .on('mouseover', function (d) {
        tip.show(`${d.nombre}`, this)
      })

    // tag manipuleo
    g.selectAll('.manipuleoFondo')
      .data([sectores['S5']])
      .enter()
      .append('polygon')
      .attr('points', (d) =>
        `${xScale(d.startingXPosition + (d.xLarge / 2 + 1) - 8)},${yScale(sectores['S3'].zLarge + 5.5 - 1)} 
        ${xScale(d.startingXPosition + (d.xLarge / 2 + 1) + 8)},${yScale(sectores['S3'].zLarge + 5.5 - 1)} 
        ${xScale(d.startingXPosition + (d.xLarge / 2 + 1) + 8)},${yScale(sectores['S3'].zLarge + 5.5 + 1)} 
        ${xScale(d.startingXPosition + (d.xLarge / 2 + 1))},${yScale(sectores['S3'].zLarge + 5.5 + 2)} 
        ${xScale(d.startingXPosition + (d.xLarge / 2 + 1) - 8)},${yScale(sectores['S3'].zLarge + 5.5 + 1)} 
        `
      )
      .attr('opacity', 0.6)
      .style('fill', '#bdbdbd')
      .attr('class', (d) => `selectorDeLinea ${d}`)
      .on('mouseover', () => this.lineaHover('S5', silos, entresilos, lineas))
      .on('mouseout', () => this.lineaHoverOff('S5', silos, entresilos, lineas))
    g.selectAll('.manipuleoTexto')
      .data([sectores['S5']])
      .enter()
      .append('text')
      .attr('x', (d) => xScale(d.startingXPosition + (d.xLarge / 2 + 1)))
      .attr('y', (d) => yScale(sectores['S3'].zLarge + 5.5))
      .attr('class', `lineaManipuleo`)
      .attr('opacity', 1)
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'central')
      .text('S5 - MANIPULEO')
      .on('mouseover', () => this.lineaHover('S5', silos, entresilos, lineas))
      .on('mouseout', () => this.lineaHoverOff('S5', silos, entresilos, lineas))

    // tag sector 4
    g.selectAll('.sector4Fondo')
      .data([sectores['S4']])
      .enter()
      .append('polygon')
      .attr('points', (d) =>
        `${xScale(d.startingXPosition + (d.xLarge / 2 + 1) - 8)},${yScale(sectores['S3'].zLarge + 5.5 - 1)} 
      ${xScale(d.startingXPosition + (d.xLarge / 2 + 1) + 8)},${yScale(sectores['S3'].zLarge + 5.5 - 1)} 
      ${xScale(d.startingXPosition + (d.xLarge / 2 + 1) + 8)},${yScale(sectores['S3'].zLarge + 5.5 + 1)} 
      ${xScale(d.startingXPosition + (d.xLarge / 2 + 1))},${yScale(sectores['S3'].zLarge + 5.5 + 2)} 
      ${xScale(d.startingXPosition + (d.xLarge / 2 + 1) - 8)},${yScale(sectores['S3'].zLarge + 5.5 + 1)} 
      `
      )
      .attr('opacity', 0.6)
      .style('fill', '#bdbdbd')
      .attr('class', (d) => `selectorDeLinea ${d}`)
      .on('mouseover', () => this.lineaHover('L4-S4', silos, entresilos, lineas))
      .on('mouseout', () => this.lineaHoverOff('L4-S4', silos, entresilos, lineas))
    g.selectAll('.sector4Texto')
      .data([sectores['S4']])
      .enter()
      .append('text')
      .attr('x', (d) => xScale(d.startingXPosition + (d.xLarge / 2 + 1)))
      .attr('y', (d) => yScale(sectores['S2'].zLarge + 5.5))
      .attr('class', `lineaS4`)
      .attr('opacity', 1)
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'central')
      .text('S4')
      .on('mouseover', () => this.lineaHover('L4-S4', silos, entresilos, lineas))
      .on('mouseout', () => this.lineaHoverOff('L4-S4', silos, entresilos, lineas))

    // sectoresLlaves
    const selection = g.selectAll('.sectoresLlaves').data(['S1', 'S2', 'S3']).enter()
    selection
      .append('text')
      .attr('x', (d) => xScale(sectores[d].startingXPosition + sectores[d].xLarge / 2))
      .attr('y', (d) => yScale(sectores[d].startingZPosition - 0.3 + MARGEN_ENTRE_TEXTO_SECTORES_Y_PROGRESS_BAR))
      .attr('class', (d) => `lineaTexto2 ${d}`)
      .attr('opacity', 1)
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'central')
      .text((d) => d.toUpperCase())
    selection
      .append('line')
      .attr('x1', (d) => xScale(sectores[d].startingXPosition + 1))
      .attr('x2', (d) => xScale(sectores[d].startingXPosition - 2 + sectores[d].xLarge / 2))
      .attr('y1', (d) => yScale(sectores[d].startingZPosition - 0.3))
      .attr('y2', (d) => yScale(sectores[d].startingZPosition + MARGEN_ENTRE_TEXTO_SECTORES_Y_PROGRESS_BAR - 0.3))
      .attr('stroke', '#eeeeee')
      .attr('stroke-width', yScale(0.4))
      .attr('stroke-opacity', 0.6)
    selection
      .append('line')
      .attr('x1', (d) => xScale(sectores[d].startingXPosition + 2 + sectores[d].xLarge / 2))
      .attr('x2', (d) => xScale(sectores[d].startingXPosition + sectores[d].xLarge - 1))
      .attr('y1', (d) => yScale(sectores[d].startingZPosition + MARGEN_ENTRE_TEXTO_SECTORES_Y_PROGRESS_BAR - 0.3))
      .attr('y2', (d) => yScale(sectores[d].startingZPosition - 0.3))
      .attr('stroke', '#eeeeee')
      .attr('stroke-width', yScale(0.4))
      .attr('stroke-opacity', 0.6)

    // entresilos
    g.selectAll('.entresilo')
      .data(entresilos)
      .enter()
      .append('rect')
      .attr('transform', (d) => `rotate(45,${xScale(d.posicionX)},${yScale(d.posicionZ)})`)
      .attr('x', (d) => xScale(d.posicionX) - rScale(d.radio))
      .attr('y', (d) => yScale(d.posicionZ) - rScale(d.radio))
      .attr('width', (d) => rScale(d.radio) * 2)
      .attr('height', (d) => rScale(d.radio) * 2)
      .attr('opacity', 1)
      .style('fill-opacity', (d) => (d.estado && d.estado === 'V' ? 0 : 1))
      .attr('clip-path', (d) => d.estado === 'U' ? `polygon(0% ${'' + (d.metrosDeVacio * 100 / d.alturaTotal) + '%'
      }, 100% ${'' + (d.metrosDeVacio * 100 / d.alturaTotal) + '%'}, 100% 100%, 0 100%)` : '')
      .attr('class', (d) => `entresilo ${d.nombre}`)
      .style('fill', (d) => `${(!d.habilitado) ? '#000000' : d.color ? (d.color.startsWith('#') ? d.color : `#${d.color}`) : '#757575'}`)
      .style('stroke', 'rgba(35, 31, 32, 0.1)')
      .style('stroke-width', 6)
      // Filtro de Cereal y Variedad
      .style('fill-opacity', (d) => (filtrado ? (d.cereal === cereal && d.cerealVariedad === variedad) ? 1 : 0 : 1))
      .on('click', (d) => this.props.onClickSilo(d))
      .on('mouseover', function (d) {
        tip.show(`${d.nombreCorto} ${d.metrosDeVacio
          ? (d.etiqueta != null) ? ' (' + d.metrosDeVacio + ' mts) ' + d.etiqueta : ' (' + d.metrosDeVacio + ' mts)'
          : (d.etiqueta != null) ? d.etiqueta : ''}`, this)
      })
      .on('mouseout', tip.hide)
    g.selectAll('.entresiloStroke')
      .data(entresilos)
      .enter()
      .append('rect')
      .attr('transform', (d) => `rotate(45,${xScale(d.posicionX)},${yScale(d.posicionZ)})`)
      .attr('x', (d) => xScale(d.posicionX) - rScale(d.radio))
      .attr('y', (d) => yScale(d.posicionZ) - rScale(d.radio))
      .attr('width', (d) => rScale(d.radio) * 2)
      .attr('height', (d) => rScale(d.radio) * 2)
      .attr('opacity', 1)
      .attr('stroke-width', 1)
      .attr('stroke', '#757575')
      .style('fill-opacity', 0)
      .attr('class', (d) => `entresiloStroke ${d.nombre}`)
      .on('click', (d) => this.props.onClickSilo(d))
      .on('mouseover', function (d) {
        tip.show(`${d.nombreCorto} ${d.metrosDeVacio
          ? (d.etiqueta != null) ? ' (' + d.metrosDeVacio + ' mts) ' + d.etiqueta : ' (' + d.metrosDeVacio + ' mts)'
          : (d.etiqueta != null) ? d.etiqueta : ''}`, this)
      })
      .on('mouseout', tip.hide)
    // silos
    g.selectAll('.silo')
      .data(silos)
      .enter()
      .append('circle')
      .attr('opacity', 1)
      .attr('cx', (d) => xScale(d.posicionX))
      .attr('cy', (d) => yScale(d.posicionZ))
      .attr('r', (d) => rScale(d.sector === 'S5' ? d.radio * 1.5 : d.radio * 1.2))
      .style('fill-opacity', (d) => (d.estado && d.estado === 'V' ? 0 : 1))
      .attr('clip-path', (d) => d.estado === 'U' ? `polygon(0% ${'' + (d.metrosDeVacio * 100 / d.alturaTotal) + '%'
      }, 100% ${'' + (d.metrosDeVacio * 100 / d.alturaTotal) + '%'}, 100% 100%, 0 100%)` : '')
      .attr('class', (d) => `silo ${d.nombre}`)
      .style('fill', (d) => `${(!d.habilitado) ? '#000000' : d.color ? (d.color.startsWith('#') ? d.color : `#${d.color}`) : '#757575'}`)
      .style('stroke', 'rgba(35, 31, 32, 0.1)')
      .style('stroke-width', 6)
      // Filtro de Cereal y Variedad
      .style('fill-opacity', (d) => (filtrado ? (d.cereal === cereal && d.cerealVariedad === variedad) ? 1 : 0 : 1))
      .on('click', (d) => this.props.onClickSilo(d))
      .on('mouseover', function (d) {
        tip.show(`${d.nombreCorto} ${d.metrosDeVacio
          ? (d.etiqueta != null) ? ' (' + d.metrosDeVacio + ' mts) ' + d.etiqueta : ' (' + d.metrosDeVacio + ' mts)'
          : (d.etiqueta != null) ? d.etiqueta : ''}`, this)
      })
      .on('mouseout', tip.hide)
    g.selectAll('.siloStroke')
      .data(silos)
      .enter()
      .append('circle')
      .attr('opacity', 1)
      .attr('cx', (d) => xScale(d.posicionX))
      .attr('cy', (d) => yScale(d.posicionZ))
      .attr('r', (d) => rScale(d.sector === 'S5' ? d.radio * 1.5 : d.radio * 1.2))
      .attr('stroke-width', 1)
      .attr('stroke', '#757575')
      .style('fill-opacity', 0)
      .attr('class', (d) => `siloStroke ${d.nombre}`)
      // .on('click', (d) => this.props.mostrarDetallesSilo(d))
      .on('click', (d) => this.props.onClickSilo(d))
      .on('mouseover', function (d) {
        tip.show(`${d.nombreCorto} ${d.metrosDeVacio
          ? (d.etiqueta != null) ? ' (' + d.metrosDeVacio + ' mts) ' + d.etiqueta : ' (' + d.metrosDeVacio + ' mts)'
          : (d.etiqueta != null) ? d.etiqueta : ''}`, this)
      })
      .on('mouseout', tip.hide)
  }

  render () {
    return (
      <div style={{ overflowX: 'scroll', textAlign: 'left' }}>
        {!this.props.loading && <svg ref={(node) => (this.node = node)} width={this.props.width} height={this.props.height} />}
        {this.props.loading && <Loading />}
      </div>
    )
  }
}
